import {
  SALE_ORDERS,
  SALE_ORDERS_ERROR,
  CLEAN_SALE_ORDERS,
  CLEAN_SALE_ORDERS_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
  pagination: {
    page: 1,
    pages: 1,
    size: 10,
    total_rows: 0,
  },
};

export default function saleOrdersReducer(state = initialState, action) {
  switch (action.type) {
    case SALE_ORDERS:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
        pagination: action?.payload?.pagination || state.pagination,
      };

    case SALE_ORDERS_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_SALE_ORDERS:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
        pagination: initialState.pagination,
      };

    case CLEAN_SALE_ORDERS_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
        pagination: initialState.pagination,
      };
    default:
      return state;
  }
}
